// Facebook.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Facebook = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    en: "https://www.facebook.com/condesahotelalcudia/",
  };

  return (
    <>
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text" id="fade">Facebook</span>
        <i className="bi bi-facebook"></i>
      </button>
      {showModal && <LanguageModal title="Facebook" icon="bi bi-facebook" links={links} onClose={() => setShowModal(false)} />}
    </>
  );
};

export default Facebook;